import { render, staticRenderFns } from "./RelatedCustomerStory.vue?vue&type=template&id=25647066"
import script from "./RelatedCustomerStory.vue?vue&type=script&lang=js"
export * from "./RelatedCustomerStory.vue?vue&type=script&lang=js"
import style0 from "./RelatedCustomerStory.vue?vue&type=style&index=0&id=25647066&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports